module.exports = __webpack_public_path__ + "img/exclude.21ef0a12.svg";